export default __webpack_public_path__ + "static/media/pragyaa_header.0cf3f576.jpeg";